var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProofOfRecordPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 1,
    fill: "#49596A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49195 4.48604C3.54132 4.44764 3.58658 4.40421 3.64189 4.37312L6.38429 2.83072C6.76463 2.61632 7.23686 2.61632 7.61721 2.83072L10.3601 4.37358C10.4154 4.40466 10.4602 4.44764 10.5095 4.48604L7.00052 6.59118L3.49195 4.48604ZM6.65812 7.18546L3.08555 5.04192C3.03572 5.17769 3.00098 5.31986 3.00098 5.46889V8.51346C3.00098 8.96695 3.24646 9.38661 3.64143 9.60878L6.38429 11.1516C6.47115 11.2005 6.56349 11.2353 6.65812 11.2618V7.18546ZM7.34383 7.18546V11.2618C7.438 11.2353 7.53081 11.2005 7.61766 11.1516L10.3605 9.60878C10.7555 9.38661 11.001 8.96695 11.001 8.51346V5.46889C11.001 5.31986 10.9658 5.17815 10.9164 5.04192L7.34383 7.18546Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfRecordPending);
export default __webpack_public_path__ + "static/media/proof_of_record_pending.f4c04458201f161b83c046313e226696.svg";
export { ForwardRef as ReactComponent };